import * as React from "react";
import { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";

import Button from "../../../components/UI/Button/Button";

import classes from "./DiscardBilling.module.css";

interface IParentProps {
  cancelDiscard: () => void;
  confirmDiscard: () => void;
  t:any;
}


type Props = IParentProps;
class DiscardBilling extends Component<Props> {
  render() {
    const {t} = this.props;
    const { cancelDiscard, confirmDiscard } = { ...this.props };
    const nextBtnStyle = {
      minWidth: "120px"
    };
    return (
      <Fragment>
      <div className={classes.popupBody}>
        <h6>
          {t('discardBilling.areYouSure')} <br />{t('discardBilling.youWant')}  <br />{t('discardBilling.allTheChanges')}{" "}
        </h6>
        <div className={classes.closeBtn} onClick={cancelDiscard}>X</div>
        <div className="flexButtons">
          <Button
            label={t('balanceBilling.cancelBtn')}
            clicked={cancelDiscard}
            style={nextBtnStyle}
            displayImg={false}
            image=""
            disabled={false}
          />
          <Button
            label={t('feedBack.confirm')}
            clicked={confirmDiscard}
            style={nextBtnStyle}
            displayImg={false}
            image=""
            disabled={false}
          />
        </div>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation()(DiscardBilling);
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DiscardBilling));
